
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import keymaster from 'keymaster';
import moment from 'moment';
import roles from '../utils/roles';
import _ from 'lodash';

import Spinner from './Spinner';

import ProjectItem from './ProjectItem';
import ApprovalHeader from './ApprovalHeader';

import approvedHourActions from '../actions/approvedHourActionCreators';
import projectActions from '../actions/projectActionCreators';
import timesheetActions from '../actions/timesheetActionCreators';
import weekApprovalUiActions from "../actions/weekApprovalUiActionCreators";
import Time from "../utils/time";

require.ensure([], () => {
  require('./WeekSheetApproval.less');
});

class WeekSheetApproval extends React.Component {

  projectId = 0;
  taskKey = 0;
  myOpenTask = 0;
  myOpenProject = 0;
  otherOpenTask = 0;
  otherOpenProject = 0;
  firstLoad = true;
  skipLastTaskCheck = true;

  constructor(props, context) {
    super(props, context);

    let date = null;
    if (this.props.location.query.week) {
      let yearWeek = this.props.location.query.week;
      let year = yearWeek.substring(0, 4);
      let week = yearWeek.substring(4, 6);

      date = moment().year(year).isoWeek(week).day(1);
    } else {
      date = moment().subtract(1, "week").day(1);
    }

    this.state = {
      date
    };
  }

  // LIFECYCLE METHODS
  componentDidMount = () => {
    moment.updateLocale('en', {
      week: {doy: 4, dow: 1}
    });

    this.handleLoad();

    keymaster('left', this.decrementWeek);
    keymaster('right', this.incrementWeek);
  }

  componentWillReceiveProps = (nextProps) => {

    if (nextProps.currentUser) {
      //way to transition to root using react-router if user has no roles
      if (!roles.userHasAnyOfRoles(nextProps.currentUser, ['LM', 'PM'])) {
        browserHistory.push('/');
      }
      if (!_.isEqual(this.props.myProjects, nextProps.myProjects) || this.firstLoad) {
        this.unfoldFirstApprovableProjectOrReset(nextProps.myProjects);
        this.firstLoad = false;
      }
    }
  }

  componentWillUnmount = () => {
    keymaster.unbind('left');
    keymaster.unbind('right');
  }

  // EVENT HANDLERS
  handleApprove = (approvedHoursID, timesheetID, projectKey, taskKey, approvedHourKey) => {
    let approverName = this.props.currentUser.givenName + " " + this.props.currentUser.surname;

    this.props.dispatch(approvedHourActions.approve(approvedHoursID, timesheetID, projectKey, taskKey, approvedHourKey));
    setTimeout(() => {
      this.props.dispatch(approvedHourActions.countUnapproved());
    }, 150);

    this.setProjectId(this.props.myProjects[projectKey].id);

    if (this.props.myProjects[projectKey].tasks[taskKey].toApprove === 1) {
      this.taskKey = taskKey + 1;
    }

  }

  handleDateChange = (date) => {
    if (this.props.loading) return;

    moment.updateLocale('en', {
      week: {doy: 4, dow: 1}
    });

    this.setState({
      date: moment(date, "YYYY-MM-DD").startOf('isoweek')
    }, () => {
      //Callback
      this.handleLoad();
    });

    this.resetFoundProject();
  }

  handleLoad = () => {
    if (this.checkUserRoles()) {
      let formattedYearAndWeek = Time.getFormattedYearAndWeek(this.state.date);
      this.props.dispatch(projectActions.loadMyProjectsForWeekApproval(formattedYearAndWeek));
      this.props.dispatch(projectActions.loadOtherProjectsForWeekApproval(formattedYearAndWeek));
      this.props.dispatch(approvedHourActions.setCurrentApprovalWeek(formattedYearAndWeek));
    }
  }

  handleMyProjectItemClick = (key) => {

    this.setProjectId(this.props.myProjects[key].id);

    if (this.props.myProjectOpen[this.findIndexOfProject(this.props.myProjects)] === undefined) {
      this.props.dispatch(weekApprovalUiActions.resetMyProjectOpen());
      this.props.dispatch(weekApprovalUiActions.toggleMyProjectOpen(this.findIndexOfProject(this.props.myProjects)));
    } else {
      this.props.dispatch(weekApprovalUiActions.toggleMyProjectOpen(this.findIndexOfProject(this.props.myProjects)));
    }

    this.props.dispatch(weekApprovalUiActions.resetMyTaskOpen());
    const taskKey = this.props.myProjects[this.findIndexOfProject(this.props.myProjects)].tasks.findIndex(task => task.toApprove > 0);

    this.props.dispatch(weekApprovalUiActions.unfoldMyTask(this.findIndexOfProject(this.props.myProjects), taskKey));

    this.setOpenTask(this.findIndexOfProject(this.props.myProjects), taskKey);

    this.taskKey = 0;

    this.forceUpdate();
  }

  handleOtherProjectItemClick = (key) => {

    if (this.props.otherProjectOpen[key] === undefined) {
      this.props.dispatch(weekApprovalUiActions.resetOtherProjectOpen());
      this.props.dispatch(weekApprovalUiActions.toggleOtherProjectOpen(key));
    } else {
      this.props.dispatch(weekApprovalUiActions.toggleOtherProjectOpen(key));
    }

    this.props.dispatch(weekApprovalUiActions.resetOtherTaskOpen());
    const taskKey = this.props.otherProjects[key].tasks.findIndex(task => task.toApprove > 0);

    this.props.dispatch(weekApprovalUiActions.unfoldOtherTask(key, taskKey));

    this.setOpenTask(key, taskKey, "other");

    this.forceUpdate();
  }

  handleMyTaskItemClick = (projectKey, taskKey) => {

    this.setTaskKey(taskKey);

    this.setProjectId(this.props.myProjects[projectKey].id);

    if (this.myOpenProject === this.findIndexOfProject(this.props.myProjects) && this.myOpenTask === taskKey) {
      this.props.dispatch(weekApprovalUiActions.toggleMyTaskOpen(this.findIndexOfProject(this.props.myProjects), taskKey));
    } else {
      this.props.dispatch(weekApprovalUiActions.resetMyTaskOpen());
      this.props.dispatch(weekApprovalUiActions.toggleMyTaskOpen(this.findIndexOfProject(this.props.myProjects), taskKey));
    }

    this.setOpenTask(this.findIndexOfProject(this.props.myProjects), taskKey);

    this.forceUpdate();
  }

  handleOtherTaskItemClick = (projectKey, taskKey) => {

    if (this.otherOpenProject === projectKey && this.otherOpenTask === taskKey) {
      this.props.dispatch(weekApprovalUiActions.toggleOtherTaskOpen(projectKey, taskKey));
    } else {
      this.props.dispatch(weekApprovalUiActions.resetOtherTaskOpen());
      this.props.dispatch(weekApprovalUiActions.toggleOtherTaskOpen(projectKey, taskKey));

      this.setOpenTask(projectKey, taskKey, "other");
    }

    this.forceUpdate();
  }

  handleReject = (timesheetID, approvedHoursID, message, projectKey, taskKey) => {
    this.props.dispatch(timesheetActions.reject(timesheetID, approvedHoursID, message,
      this.props.currentUser, moment().format("YYYY-MM-DD")));

    setTimeout(() => {
      this.handleLoad();
      this.props.dispatch(approvedHourActions.countUnapproved());
    }, 150);

    this.setProjectId(this.props.myProjects[projectKey].id);

    if (this.props.myProjects[projectKey].tasks[taskKey].toApprove === 1) {
      this.taskKey = taskKey + 1;
    }

  }

  // OTHER METHODS
  checkUserRoles = () => {
    if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PM', 'LM']))
      return true;

    return false;
  }

  countHours = (project, status) => {
    let sum = 0;
    project.tasks.map((task) => {
      task.approvedHours.map((approvedHour) => {
        if (approvedHour.status === status || (status === "ENTRY" && approvedHour.status === "FIXING"))
          sum += approvedHour.regularTime;
      })
    });
    if (sum % 60 === 0)
      return sum / 60 + "h";
    else
      return `${Math.floor(sum / 60)}h ${sum % 60}min`;
  }

  decrementWeek = () => {
    if (this.props.loading) return;

    this.setState({
      date: this.state.date.subtract(7, 'days')
    }, () => {
      this.handleLoad();
    });

    this.resetFoundProject();
  }

  incrementWeek = () => {
    if (this.props.loading) return;

    this.setState({
      date: this.state.date.add(7, 'days')
    }, () => {
      this.handleLoad();
    });

    this.resetFoundProject();
  }

  makeProjectNames = (projects) => {
    let projectNames = [];
    for (let i = 0; i < projects.length; i++) {
      projectNames.push(projects[i].name);
    }
    return projectNames;
  }

  setOpenTask = (projectKey, taskKey, flag = "my") => {
    if (flag === "my") {
      this.myOpenProject = projectKey;
      this.myOpenTask = taskKey;
    } else if (flag === "other") {
      this.otherOpenProject = projectKey;
      this.otherOpenTask = taskKey;
    }
  }

  setTaskKey = (key) => {
    this.taskKey = key;
  }

  findIndexOfProject = (projects) => {
    const i = projects.findIndex(p => p.id === this.projectId);

    if (i === -1) {
      return 0;
    }

    return i;
  }

  setProjectId = (id) => {
    this.projectId = id;
  }

  resetFoundProject = () => {
    this.props.dispatch(weekApprovalUiActions.resetAllProjectsAndTasks());
    this.projectId = 0;
    this.skipLastTaskCheck = true;
  }

  isLastApprovableTaskOpened = (project, openedTaskKey) => {
    let tasks = project.tasks;

    if (openedTaskKey === -1) {
      return false;
    }

    for (let i = tasks.length - 1; i > openedTaskKey; i--) {
      if (tasks[i].toApprove > 0) {
        return false;
      }
    }

    return true;
  }

  unfoldFirstApprovableProjectOrReset(projects) {
    let project, projectKey, taskKey, task;
    let foundProject = false;
    let foundTask = false;
    let activeProjectId = this.projectId;

    //restartaj projekt ako je:
    //riješen zadnji projekt na listi
    if (this.findIndexOfProject(projects) + 1 === projects.length && projects[this.findIndexOfProject(projects)].toApprove === 0) {
      if (projects.length > 0) {
        this.setProjectId(projects[0].id);

        this.setOpenTask(this.findIndexOfProject(projects), -1);
      }
    }

    for (let i = this.findIndexOfProject(projects); i < projects.length; i++) {
      // Skip check on sheet load
      // Go to next project only if approval completes the task (case when there is only one more user in task to approve)
      if (!this.skipLastTaskCheck && i === this.findIndexOfProject(projects)
        && this.isLastApprovableTaskOpened(projects[i], this.myOpenTask) && projects[i].tasks[this.myOpenTask].toApprove === 0) {
        continue;
      }

      if (projects[i].toApprove > 0) {
        project = projects[i];
        this.setProjectId(project.id);
        foundProject = true;
        break;
      }
    }

    if (!foundProject) {
      for (let i = 0; i < this.findIndexOfProject(projects); i++) {
        if (projects[i].toApprove > 0) {
          project = projects[i];
          this.setProjectId(project.id);
          foundProject = true;
          break;
        }
      }
    }

    // find first approvable project
    /*projects.forEach((p, i) => {
      if (!foundProject && p.toApprove > 0) {
        project = p;
        projectKey = i;
        foundProject = true;
      }
    });*/

    if (foundProject) {

      //postavi na nulu this.taskKey ako:
      //si rješio sve taskove na projektu
      //si rještio zadnji task u projektu
      if (activeProjectId !== this.projectId
        || project.tasks.length === this.taskKey
        || project.tasks.slice(this.taskKey).every(t => t.toApprove === 0)) {
        this.taskKey = 0;
      }

      for (let i = this.taskKey; project.tasks.length; i++) {
        if (project.tasks[i].toApprove > 0) {
          task = project.tasks[i];
          taskKey = i;
          foundTask = true;
          break;
        }
      }

      /*project.tasks.forEach((t, i) => {
        if (!foundTask && t.toApprove > 0) {
          task = t;
          taskKey = i;
          foundTask = true;
        }
      });*/
    }

    if (foundProject && foundTask) {
      this.props.dispatch(weekApprovalUiActions.resetAllProjectsAndTasks());
      this.props.dispatch(weekApprovalUiActions.unfoldMyProject(this.findIndexOfProject(projects)));
      this.props.dispatch(weekApprovalUiActions.unfoldMyTask(this.findIndexOfProject(projects), taskKey));

      this.setOpenTask(this.findIndexOfProject(projects), taskKey);

      this.skipLastTaskCheck = false;
    }
  }

  // RENDER METHOD
  render = () => {
    if (this.props.loading) {
      return (
        <div className="container">
          <br/>
          <ApprovalHeader
            date={this.state.date}
            decrementWeek={this.decrementWeek}
            endDay={this.state.date.clone().add(6, 'days')}
            incrementWeek={this.incrementWeek}
            loading={this.props.loading}
            startDay={this.state.date}
          />
          <br/>
          <br/>
          <Spinner/>
        </div>
      );
    }

    if (!this.props.loading
      && ((this.props.myProjects && this.props.myProjects.length == 0)
        && (this.props.otherProjects && this.props.otherProjects.length == 0))) {
      return (
        <div className="container">
          <br/>
          <ApprovalHeader
            date={this.state.date}
            decrementWeek={this.decrementWeek}
            endDay={this.state.date.clone().add(6, 'days')}
            handleDateChange={this.handleDateChange}
            incrementWeek={this.incrementWeek}
            loading={this.props.loading}
            startDay={this.state.date}
          />
          <div className="row project">
            <div className="col-lg-10 col-lg-offset-1 col-md-12">
              <div className="panel-group" id="accordion-outer" role="tablist" aria-multiselectable="true">
                <br/><h4 className="text-center">There is nothing to approve</h4>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="container">
        <br/>
        <ApprovalHeader
          date={this.state.date}
          decrementWeek={this.decrementWeek}
          endDay={this.state.date.clone().add(6, 'days')}
          handleDateChange={this.handleDateChange}
          incrementWeek={this.incrementWeek}
          loading={this.props.loading}
          startDay={this.state.date}
        />
        <div className="row project">
          <div className="col-lg-10 col-lg-offset-1 col-md-12">
            <div className="panel-group" id="accordion-outer" role="tablist" aria-multiselectable="true">
              {
                this.props.myProjects && this.props.myProjects.length > 0
                  ? <h4>My approvals:</h4>
                  : null
              }
              {
                this.props.myProjects ?
                  this.props.myProjects.map((project, projectKey) => {
                    return <ProjectItem
                      active={this.props.myProjectOpen[projectKey]}
                      date={this.state.date}
                      defaultColor={project.defaultColor}
                      handleApprove={this.handleApprove}
                      handleClick={this.handleMyProjectItemClick}
                      handleReject={this.handleReject}
                      handleTaskItemClick={this.handleMyTaskItemClick}
                      formattedHoursApproved={this.countHours(project, "APPROVED")}
                      formattedHoursEntry={this.countHours(project, "ENTRY")}
                      formattedHoursSubmitted={this.countHours(project, "SUBMITTED")}
                      id={projectKey}
                      key={projectKey}
                      projectName={project.name}
                      projectNames={this.makeProjectNames(this.props.myProjects)}
                      projectKey={projectKey}
                      showBadge
                      shouldApprove
                      taskOpen={this.props.myTaskOpen[projectKey]}
                      tasks={project.tasks}
                      toApprove={project.toApprove}
                    />;
                  }) : null
              }
              {
                this.props.otherProjects && this.props.otherProjects.length > 0
                  ? <h4>Other approvals:</h4>
                  : null
              }
              {
                this.props.otherProjects ?
                  this.props.otherProjects.map((project, projectKey) => {
                    return <ProjectItem
                      active={this.props.otherProjectOpen[projectKey]}
                      date={this.state.date}
                      defaultColor={project.defaultColor}
                      handleClick={this.handleOtherProjectItemClick}
                      handleTaskItemClick={this.handleOtherTaskItemClick}
                      formattedHoursApproved={this.countHours(project, "APPROVED")}
                      formattedHoursEntry={this.countHours(project, "ENTRY")}
                      formattedHoursSubmitted={this.countHours(project, "SUBMITTED")}
                      id={projectKey}
                      key={projectKey}
                      projectKey={projectKey}
                      projectName={project.name}
                      projectNames={this.makeProjectNames(this.props.otherProjects)}
                      shouldApprove={false}
                      tasks={project.tasks}
                      taskOpen={this.props.otherTaskOpen[projectKey]}
                      toApprove={project.toApprove}
                    />;
                  }) : null
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

WeekSheetApproval.contextTypes = {
  router: PropTypes.object.isRequired
};

WeekSheetApproval.propTypes = {
  currentUser: PropTypes.object,
  dispatch: PropTypes.func,
  loading: PropTypes.bool,
  myProjects: PropTypes.array,
  otherProjects: PropTypes.array,
  routeParams: PropTypes.object,
  myProjectOpen: PropTypes.array,
  otherProjectOpen: PropTypes.array,
  myTaskOpen: PropTypes.array,
  otherTaskOpen: PropTypes.array
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.users.currentUser,
    loading: state.projects.loading || state.projects.otherProjectsLoading,
    myProjects: state.projects.myProjectsForWeekApproval,
    otherProjects: state.projects.otherProjectsForWeekApproval,
    myProjectOpen: state.weekApprovalUi.myProjectOpen,
    otherProjectOpen: state.weekApprovalUi.otherProjectOpen,
    myTaskOpen: state.weekApprovalUi.myTaskOpen,
    otherTaskOpen: state.weekApprovalUi.otherTaskOpen,
    currentWeek: state.weekApprovalUi.currentWeek
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WeekSheetApproval);



/** WEBPACK FOOTER **
 ** ./src/app/components/WeekSheetApproval.js
 **/